module.exports = __webpack_public_path__ + "img/contact_section_image.32885d09.png";